function initialStateFromSchema(schema) {
	const initialState = {}
	for (const key in schema.properties) {
		const prop = schema.properties[key]
		if ('initial' in prop) {
			initialState[key] = prop.initial
		} else if ('properties' in prop) {
			initialState[key] = initialStateFromSchema(prop)
		} else {
			throw new Error(`No initial value for ${key} in schema`)
		}
	}
	return initialState
}

export default initialStateFromSchema
